<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>
<form [formGroup]="deviceForm" class="admin-forms truckComponent">
  <div class="accordion-class">
    <h5>Auto Generate Devices</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="mb-3 pull-left w-100">
        <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
          <mat-label>Select Module</mat-label>
          <mat-select dropLocationSearchField formControlName="_id" required>
            <mat-option *ngFor='let gps of GpsTypeData' value="{{gps._id}}">
              {{gps.server_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue" (click)="submit()">
    Submit </button>
</form>